<mat-card>
  <div #exportContent>
    <div class="header">
      <div class="title">County-level Map of Total Cost Per Customer (Residential & Non-Residential)</div>
      <button class="header-btn" data-html2canvas-ignore mat-icon-button (click)="export()">
        <vulcan-icon size="24px" icon="download"></vulcan-icon>
      </button>
    </div>
    <mat-card-content>
      <div>
        <tgrid-map [mapId]="mapId" hideAppState></tgrid-map>
      </div>
      @let legendBounds = (sourceRef | async)?.legendBounds();
      @if (legendBounds) {

          <div class="legend" #legendContent>
            <div class="legend-left">
              <div class="legend-key">
                <div class="legend-item">
                  <span class="legend-swatch legend-swatch--no-data"></span>
                  <span class="legend-text">No Data</span>
                </div>
                <div class="legend-item">
                  <span class="legend-swatch legend-swatch--ntl"></span>
                  <span class="legend-text">NTL</span>
                </div>
              </div>
            </div>
            <div class="legend-right">
              <div #legendBar class="legend-bar"></div>
              <div class="legend-labels">
                <span>{{ legendBounds.min | compactCurrency }}</span>
                <span>{{ legendBounds.max | compactCurrency }}</span>
              </div>
            </div>
          </div>
      }
    </mat-card-content>
  </div>
</mat-card>
